module.exports = "/images/vendor/flag-icon-css/flags/4x3/un.svg?bdaf37f920eb89f19bf840be77b1f359";